<template>
  <v-card>
    <v-row>
      <v-col cols="12">
        <v-card class="mb-5 pa-4">
          <v-card-subtitle>
            <div>
              <strong>Bank :</strong> {{ bankDetails.bank }}<br />
              <strong>Branch:</strong> {{ bankDetails.branch }}<br />
              <strong>Account Number:</strong> {{ bankDetails.account_number
              }}<br />
              <strong>Account Type:</strong> {{ bankDetails.account_type
              }}<br />
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <!-- Transactions Table -->
    <v-data-table
      v-if="transactions.length > 0"
      :headers="transactionHeaders"
      :items="transactions"
      dense
      item-key="id"
    >
      <template v-slot:item="{ item, index }">
        <tr :class="[index % 2 === 0 ? 'dark-row' : 'light-row', 'custom-row']">
          <td>{{ item.entry_number }}</td>
          <td>{{ item.credit }}</td>
          <td>{{ item.debit }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { CompanyBankService } from "@/services/bank-service";

export default {
  data() {
    return {
      bankDetails: {},
      transactions: [],
      transactionHeaders: [
        { text: "Entry Number", value: "entry_id" },
        { text: "Credit", value: "credit" },
        { text: "Debit", value: "debit" },
      ],
    };
  },
  created() {
    this.fetchBankDetails();
    this.fetchTransactions();
  },
  methods: {
    async fetchBankDetails() {
      try {
        const response = await CompanyBankService.getBankAccountDetails(
          this.$route.params.uuid
        );
        this.bankDetails = response.data.data;
      } catch (error) {
        console.error("Error fetching bank details:", error);
      }
    },
    async fetchTransactions() {
      try {
        const response = await CompanyBankService.getTransactions(
          this.$route.params.uuid
        );
        console.log("tf"+response.data.data+"ytfgh"+response.data+"ytfg")
        this.transactions = response.data.data; 
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    },
  },
};
</script>

<style scoped>
.dark-row {
  background-color: #f4f4f4;
}
.light-row {
  background-color: #ffffff;
}
.custom-row:hover {
  background-color: #e8e8e8;
  cursor: pointer;
}
</style>
